import { render, staticRenderFns } from "./r-guard-panel.vue?vue&type=template&id=4d441d4c&scoped=true"
import script from "./r-guard-panel.vue?vue&type=script&lang=js"
export * from "./r-guard-panel.vue?vue&type=script&lang=js"
import style0 from "./r-guard-panel.vue?vue&type=style&index=0&id=4d441d4c&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d441d4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d441d4c')) {
      api.createRecord('4d441d4c', component.options)
    } else {
      api.reload('4d441d4c', component.options)
    }
    module.hot.accept("./r-guard-panel.vue?vue&type=template&id=4d441d4c&scoped=true", function () {
      api.rerender('4d441d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/guard/r-guard-panel.vue"
export default component.exports